// src/config/fareClientRules.js
// src/config/fareClientRules.js
// -----------------------------------------------------------------------------
// 🔧 Frontend Fare Configuration — mirrors backend config/fareRules.js
// -----------------------------------------------------------------------------
export const fareClientRules = {
  // ✅ Vehicle type enable/disable toggles (match backend settings)
  enable7Seater: true,   // MPV
  enable9Seater: true,   // 9-seater / minibus
  enable14Seater: true,  // partner 14-seater vehicles

  // ✅ Capacity limits (used to cap input ranges in PostcodeQuote.jsx)
  baseLimits: {
    saloon:    { passengers: 4,  bags: 2 },
    mpv:       { passengers: 6,  bags: 4 },
    minibus:   { passengers: 8,  bags: 6 },
    minibus14: { passengers: 14, bags: 10 },
  },
};

